import { message } from 'antd';
import { stopAllBotsStrategyConstants } from '../constants';

const stopAllBotsRequested = () => ({
    type: stopAllBotsStrategyConstants.STOP_ALL_STRATEGY_REQUEST,
});

const stopAllBotsRequestedLoaded = data => ({
    type: stopAllBotsStrategyConstants.STOP_ALL_STRATEGY_SUCCESS,
    payload: data,
});

const stopAllBotsRequestedError = error => ({
    type: stopAllBotsStrategyConstants.STOP_ALL_STRATEGY_FAILURE,
    payload: error,
});

const stopAllBotsStrategyAction = patchService => (body, t) => dispatch => {
    dispatch(stopAllBotsRequested());
    patchService
        .stopAllStrategy(body)
        .then(data => {
            dispatch(stopAllBotsRequestedLoaded(data));
            if (body.status === 'RUNNING') {
                message.success(t('createBot.allBotsRunning'), 2);
            } else if (body.status === 'STOPPED') {
                message.success(t('createBot.allBotsStopped'), 2);
            }
        })
        .catch(err => {
            dispatch(stopAllBotsRequestedError(err));
        });
};

export default stopAllBotsStrategyAction;
